"use client";

import * as React from "react";
import { useEffect, useRef } from "react";

import { cn } from "@/lib/utils";

interface RevealSectionProps
  extends React.HTMLAttributes<HTMLDivElement> {
  asChild?: boolean;
}

export function RevealSection({
  className,
  children,
  ...props
}: RevealSectionProps) {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === "undefined") return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            node.dataset.visible = "true";
            observer.unobserve(node);
          }
        });
      },
      { threshold: 0.15 },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      data-visible="false"
      className={cn("reveal-section", className)}
      {...props}
    >
      {children}
    </div>
  );
}

